$(function() {
  $(document).on('click', 'a[href^="#"]', function(e) {
    e.preventDefault();
    let target = $(document.getElementById($(this).attr('href').replace('#', '')));
    
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top  - $('header').outerHeight(),
      }, 1000, 'swing');
    }
  });
});
